import { render, staticRenderFns } from "./FPage.vue?vue&type=template&id=b8aee9b2&"
import script from "./FPage.vue?vue&type=script&lang=js&"
export * from "./FPage.vue?vue&type=script&lang=js&"
import style0 from "./FPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports